export const LAYOUT_CONSTANTS = {
    MIN_HEIGHT: 35,
    MAX_HEIGHT: 70,
    DROPDOWN_Z_INDEX: 1000,
    ANIMATION_DURATION: 200,
    DROPDOWN_OFFSET: 4,
} as const;

export const MESSAGES = {
    COMPANY_NOT_FOUND: '회사 정보를 찾을 수 없습니다.',
    PERIOD_CHANGE_FAILED: '기수 변경에 실패했습니다.',
    PERIOD_SELECTION_LABEL: '기수 선택',
} as const; 